import { Link as ScrollTo } from '@daredrop/react-scroll'
import React from 'react'

export default ({ anchor, children, spy = true, classes = {} }) => (
	<ScrollTo
		href={`#${anchor}`}
		className={classes}
		hashSpy={spy}
		to={anchor}
		smooth
		duration={500}
		spyThrottle={500}
	>
		{children}
	</ScrollTo>
)
